module.exports = __webpack_public_path__ + "static/img/big_data2.7331c85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/big_data2.png
// module id = bVqj
// module chunks = 0